// extracted by mini-css-extract-plugin
export default {"holder":"coming-soon_holder__l-r-8","content":"coming-soon_content__afhlz","empty-main":"coming-soon_empty-main__bLT4E"};